module.exports = __webpack_public_path__ + "assets/084d0c5d7a2b545624f7b19f257f9202.png";